var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize"}],staticClass:"layout",class:_vm.classObject},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"content-wrap",attrs:{"id":"content-wrap"}},[_vm._t("content")],2),_vm._v(" "),_c('div',{},[_vm._t("footer")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38ebb4ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vuestic-theme/vuestic-components/vuestic-layout/VuesticLayout.vue
// module id = 8f70
// module chunks = 69